<template>
  <div class="pad-20" v-if="activeRequest">
    <div class="progress">
      <div class="progress-bar progress-bar-success progress-bar-striped active" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%">
          <span class="sr-only">{{ $t('OrderDetails.creatingOrder') }}</span>
      </div>
    </div>
    <div class="a-c">Loading STL ...</div>
  </div>
  <div v-else class="stlviewer">
    <div
      ref="container"
      class="app3d-main-panel"
      data-gpu="It seems that your graphic card does not support WebGL. Without it we cannot show you the 3D model.<br />Try using another browser."
      data-webgl="Your browser does not support WebGL. Without it we cannot show you the 3D model.<br />Only for modern browsers & IE11+"
    ></div>
  </div>
</template>

<script>

var Preloader = require('../Jaws3d/preloader.js');

var view = require('../view.js'),
    viewData = {
      isHidden: true,
      isOpen: false,
      activeRequest: false,
      alertTitle: '',
      alertText: '',
      alertStyle: '',
      alertIcon: '',
      fileHash: ''
    },
    resetData = Object.assign({}, viewData);

export default view(viewData, {
  props: {
    src: String,
    fullscreen: Boolean
  },
  mounted() {
    this.reset();
  },
  unmounted() {
    if (this.activeRequest) {
      // Cancel the current request
    }

    //dispose graphic component

    if (this.orbitControl) {
      this.orbitControl.dispose();
      this.orbitControl = null;
    }

    if (this.animRequestId) {
      cancelAnimationFrame(this.animRequestId);
      this.animRequestId = null;
    }

    this.object = null;
    this.wrapper = null;
    this.scene = null;
    this.camera = null;
    this.box = null;
    this.cameraTarget = null;

    if (this.container) {
      this.$refs.container.removeChild(this.container);

      this.renderer = null;
    }
  },
  methods: {
    reset() {
      for (var i in resetData) {
        if (resetData.hasOwnProperty(i)) {
          if (typeof resetData[i] != 'object' && i != 'isHidden' && i != 'isOpen') {
            viewData[i] = resetData[i];
          }
        }
      }

      setTimeout(() => this.init(), 300);
    },
    closeAlert() {
      this.alertTitle = '';
      this.alertText  = '';
      this.alertStyle = '';
      this.alertIcon  = '';
    },

    init() {

      const vh = (v) => v * Math.max(document.documentElement.clientHeight, window.innerHeight || 0) / 100;
      const vw = (v) => v * Math.max(document.documentElement.clientWidth, window.innerWidth || 0) / 100;

      let stlUrl = this.src;
      let width = this.fullscreen ? vw(100) : Math.min(540, vh(70));
      let height = vh(this.fullscreen ? 100 : 60);

      // this.container = this.$refs.container;

      this.container = this.createMainDomContainer(this.$refs.container);

      this.box = new THREE.Box3();
      this.wrapper = new THREE.Object3D();

      this.cameraTarget = new THREE.Vector3();
      this.camera = new THREE.PerspectiveCamera(90, width / height, 1, 500);
      this.camera.position.set(0, 0, 20);

      this.scene = new THREE.Scene();
      this.scene.add(this.wrapper);

      this.renderer = this.initRenderer(this.container.divRenderC, width, height);
      this.orbitControl = this.initOrbitControl(this.camera, this.renderer);

      this.container.loadingDiv.setPercentage(0);
      this.container.loadingDiv.setMessage('Loading ...');
      this.container.loadingDiv.show();

      let loader = new THREE.STLLoader();
      loader.load(stlUrl
        , geometry => {

          this.container.loadingDiv.updateLoader(1, 0.5);
          this.container.loadingDiv.hide();

          let material = new THREE.MeshPhongMaterial({ color: 0x0097CA, specular: 0x111111 });
          let mesh = new THREE.Mesh(geometry, material);
          mesh.applyMatrix((new THREE.Matrix4()).makeRotationAxis(new THREE.Vector3(1, 0, 0), -Math.PI / 2));
          mesh.applyMatrix((new THREE.Matrix4()).makeRotationAxis(new THREE.Vector3(0, 1, 0), -Math.PI / 6));
          this.addObject(mesh);

          this.animate();

        }, xhr => {

          // console.log(xhr);
          let percentComplete = xhr.loaded / (xhr.total || 26 * 1024 * 1024);
          // console.log('Percent ', percentComplete);
          this.container.loadingDiv.updateLoader(percentComplete, 0.3);
        }, error => {

          this.container.loadingDiv.hide();
          // console.error(error);
          window.alert('An error happened loading assets');
        }
      );

      let lightsGroup = new THREE.Group();
      this.addLights(this.getLightsMeta(), lightsGroup);
      this.scene.add(lightsGroup);
    },

    animate() {
      this.animRequestId = requestAnimationFrame(() => this.animate());
      this.camera.lookAt(this.cameraTarget);
      this.render();
    },

    updateCamera(distance) {
      this.camera.position.set(0, 0, distance);
      this.camera.lookAt(this.cameraTarget);
    },

    initRenderer(container, width, height) {
      let renderer = new THREE.WebGLRenderer({
          antialias: true,
          alpha: true
      });
      renderer.setSize(width, height);
      renderer.setClearColor(0xffffff, 1);
      renderer.setPixelRatio(window.devicePixelRatio);
      renderer.gammaInput = true;
      renderer.gammaOutput = true;

      container.appendChild(renderer.domElement);
      return renderer;
    },

    render() {
      this.camera.lookAt(new THREE.Vector3());
      this.renderer.render(this.scene, this.camera);
    },

    addLights(lights, lightsGroup){
      lights.forEach(lightObj => {
          let light = new THREE.DirectionalLight(lightObj.color, lightObj.intensity);
          light.position.set(lightObj.position.x, lightObj.position.y, lightObj.position.z);
          lightsGroup.add(light);
      });
    },

    initOrbitControl(camera, renderer){
      let orbitControl = new THREE.OrbitControls(camera, renderer.domElement);
      orbitControl.enableDamping = true;
      orbitControl.dampingFactor = 0.2;
      orbitControl.target =  new THREE.Vector3(0, 0, 0);
      orbitControl.enableKeys = false;
      orbitControl.enablePan = false;
      orbitControl.enabled = true;
      orbitControl.update();
      orbitControl.addEventListener('change', () => this.render());
      return orbitControl;
    },

    getCenter(object) {
      this.box.setFromObject(object);
      return this.box.center();
    },

    getSize(object) {
      this.box.setFromObject(object);
      return this.box.size();
    },

    addObject(object) {
      const center = this.getCenter(object);

      // correction position
      this.wrapper.position.copy(center.negate());

      this.object = object;
      this.wrapper.add(this.object);
      const distance = this.getSize(this.object).length();
      this.updateCamera(distance);
    },

    createMainDomContainer(node){
      console.log('node', node);
      let divMainC, divRenderC, divLloadingC, divLoadingText;

      //Main DOM element
      divMainC = document.createElement("div");
      divMainC.className = "app3d-container";
      divMainC.id = 'stl-viewer-main';
      // console.log(divMainC);

        //Renderer container
      divRenderC = document.createElement("div");
      divRenderC.className = "app3d-render-container";
      divRenderC.id = divMainC.id + "-render";
      divMainC.appendChild(divRenderC);
      divMainC.divRenderC = divRenderC;

      //Loading div
      divLloadingC = document.createElement("div");
      divLloadingC.className = "app3d-loading-div";
      divLloadingC.id = divMainC.id + "-loading-div";
      divMainC.appendChild(divLloadingC);

      //Loading text inside loading div
      divLoadingText = document.createElement("div");
      divLoadingText.className = "app3d-loading-div-text";
      divLoadingText.id = divMainC.id + "-loading-text";
      divLloadingC.appendChild(divLoadingText);

      //initialize loader functions
      let options = {
          loaderColor: "#B4EAE6",
          loaderColorSucess: "#4FBCB1",
      }
      divMainC.loadingDiv = new Preloader.Preloader(divLloadingC, divLoadingText, 70, options, "img-loader-logo");

      //Append to DOM element
      node.appendChild(divMainC);

      return divMainC;
    },

    getLightsMeta() {
      return [
          {
              type: 'DirectionalLight',
              position: { x: 1, y: 0, z: 0 },
              color: 0xffffff,
              intensity: 0.5
          },
          {
              type: 'DirectionalLight',
              position: { x: 0, y: 1, z: 0 },
              color: 0xffffff,
              intensity: 0.5
          },
          {
              type: 'DirectionalLight',
              position: { x: 0, y: 0, z: 1 },
              color: 0xffffff,
              intensity: 0.5
          },
          {
              type: 'DirectionalLight',
              position: { x: -1, y: 0, z: 0 },
              color: 0xffffff,
              intensity: 0.5
          }
      ];
    }
  }
});
</script>
